module.exports = __webpack_public_path__ + "img/welcome01.8cf4ee80.png";